import moment from "moment"
import {
	getFormattedDate,
	PROPRE_VEHICULE_STATUS_FONCTIONNEL,
	PROPRE_VEHICULE_TYPE_DEPANNAGE,
	DEP_STATE_CHECK_DATA,
	DEP_TYPE_TRANSPORT,
	DEPANNAGE_TYPE_APPEL_PRIVE,
	DEPANNAGE_ETAT_EN_COURS,
} from "./Addons"
import {
	ENTITE_TYPE_MASTER,
	ENTITE_TYPE_SOCIETE,
} from "../components/dashboard/entite/Entite"
import { POINT_INTERET_TYPE_ADRESSE } from "../components/others/PointInteretComponent"
import { LOCATION_ETAT_RESERVATION } from "./Constants"
import { getMasterTva, getMasterTarifJournalier } from "../store/getStore"

// TVA du système (entité Master) appliquée à la création des objets qui en ont
// une — lue depuis un cache (jamais getState() pendant un dispatch).
const masterTva = () => getMasterTva()
const masterTarifJournalier = () => getMasterTarifJournalier()

export function getBaseAtelier() {
	return {
		id: null,
		entite: null,
		vehicule: null,
		adresse: null,
		clientVehicule: -1,
		date: getFormattedDate(),
		date_prochain_travaux: "",
		kms_prochain_travaux: 0,
		etat: 0,
		employe: 0,
		kms: 0,
		total: 0,
		totalAchat: 0,
		splitPaye: false,
		isAssurance: false,
		assurance: 0,
		numeroSinistre: "",
		audatexPhotoFacture: 0,
		represente_par: "",
		doc_restitution: { url: "", saved: false },
		expert: 0,
		expertNom: "",
		isCouvertLocation: 0,
		assuranceLocation: 0,
		refLocation: "",
		nbJoursLocation: 0,
		tarifJoursLocation: 0,
		assuranceRemarques: "",
		files: [],
		paid: false,
		datePaid: "",
		boss: false,
		rabais: 0,
		franchise: 0,
		rabaisFranchise: 0,
		tva: masterTva(),
		dep: 0,
		location: 0,
		ateTransactions: [],
		svp: false,
	}
}

export function getBaseVehicule(entiteType = ENTITE_TYPE_SOCIETE) {
	return {
		id: null,
		plaques: "",
		marque: "",
		modele: "",
		chassis: "",
		date_mise_en_circu: "",
		kms: 0,
		expertise_le: "",
		carte_grise: {},
		files: [],
		is_deletable: true,
		propre_vehicule:
			entiteType === ENTITE_TYPE_MASTER ? getPropreVehicule() : null,
	}
}

export function getPropreVehicule() {
	return {
		id: null,
		parties: [],
		status: PROPRE_VEHICULE_STATUS_FONCTIONNEL,
		type: PROPRE_VEHICULE_TYPE_DEPANNAGE,
		vehicule: null,
	}
}

export function getBaseLocationObservation(label = "") {
	return {
		id: null,
		label,
	}
}

export function getPropreVehiculePartie() {
	return {
		id: null,
		label: "",
	}
}

export function getBaseFourniture() {
	return {
		id: null,
		label: "",
		operation: 0,
		valeur: 0,
	}
}

export function getBaseEntite() {
	return {
		id: null,
		label: "",
		telephone: "",
		email: "",
		type: 0,
		adresses: [getBaseAdresse()],
		personnes: [getBasePersonne()],
		vehicules: [getBaseVehicule()],
		fournitures: [getBaseFourniture()],
		extra_data: {},
		is_mauvais_payeur: false,
		can_payer_par_facture: false,
		nom: "",
		prenom: "",
		appellation: 0,
		date_naissance: "",
		date_obtention_permis: "",
		permis: "",
		numero_permis: "",
	}
}

export function getBaseAdresse() {
	return {
		id: null,
		adresse_id: null,
		rue: "",
		code_postal: "",
		localite: "",
		pays: "",
		numero: "",
		extra_data: {},
	}
}

export function getBaseLocationConducteur() {
	return {
		id: null,
		isClient: false,
		isPrimary: false,
		nom: "",
		prenom: "",
		tel: "",
		adresse: "",
		adresse2: "",
		email: "",
		dateNaissance: "",
		permis: "",
		datePermis: "",
		numeroPermis: "",
	}
}

export function getBasePersonne(type = 0) {
	return {
		id: null,
		appellation: 0,
		nom: "",
		prenom: "",
		telephone: "",
		email: "",
		date_naissance: "",
		type,
		// Colonne propre (policiers, GE-13) — "" devient NULL côté serveur.
		matricule: "",
		extra_data: {},
	}
}

export function getBasePointInteret(type = POINT_INTERET_TYPE_ADRESSE) {
	return Object.assign(
		{},
		{
			id: null,
			label: "",
			type,
			adresse: getBaseAdresse(),
		},
	)
}

// ── Objets rapatriés depuis Addons.js (getNew* → getBase*) ──

export function getBaseTransaction() {
	return Object.assign(
		{},
		{
			id: Math.random(1000) * 1000,
			date: "",
			payePar: "",
			details: "",
			adresse: "",
			moyenPaie: 0,
			caissier: 0,
			total: 0,
			raison: "",
		},
	)
}

export function getBaseCategorie() {
	return Object.assign(
		{},
		{
			id: Math.random(1000) * 1000,
			nom: "",
		},
	)
}

export function getBaseCommande() {
	return Object.assign(
		{},
		{
			id: 0,
			article: 0,
			fournisseur: 0,
			datePrevue: "",
			quantite: 0.0,
			prixAchat: 0.0,
			recu: false,
			restant: 0,
			isHT: false,
		},
	)
}

export function getBaseFournisseur() {
	return Object.assign(
		{},
		{
			id: Math.random(1000) * 1000,
			nom: "",
		},
	)
}

export function getBaseArticle() {
	return Object.assign(
		{},
		{
			id: Math.random(1000) * 1000,
			nom: "",
			categorie: 0,
			quantite: 0.0,
			prixVente: 0.0,
			totalQuantite: 0.0,
			totalPrix: 0.0,
			limite: 0.0,
			commission: 0.0,
		},
	)
}

export function getBaseVehiculeLocation() {
	return Object.assign(
		{},
		{
			id: 0,
			nom: "",
			type: 1,
			plaques: "",
			chassis: "",
			miseEnCircu: "",
			kms: "",
			expertiseLe: "",
			accidente: "",
			matricule: "",
		},
	)
}

export function getBaseLocation() {
	return Object.assign(
		{},
		{
			id: null,
			etat: LOCATION_ETAT_RESERVATION,
			entite: 0,
			adresse: 0,
			atelier: 0,
			vehicule: 0,
			dep: 0,
			kms_avant: "",
			kms_apres: "",
			dateDebut: "",
			heureDebut: "",
			nbJours: "",
			nbJoursReels: "",
			nbJoursAFacturer: null,
			nbJoursCouverts: "",
			assurance: 0,
			is_assurance: false,
			dateResti: "",
			heureResti: "",
			tarifJourna: masterTarifJournalier(),
			total: 0,
			nb_jours_sup: 0,
			supp_jours: 0,
			supp_carburant: 0,
			supp_degats: 0,
			total_supplements: 0,
			caution: "",
			cautionMoyenPaiement: 0,
			payePar: 0,
			nRef: "",
			paid: false,
			restitue: false,
			tva: masterTva(),
			isPret: false,
			transactionsv2: [],
			degatsAvant: [],
			degatsApres: [],
			photosAvant: [],
			photosApres: [],
		},
	)
}

export function getBaseLocationDegat(type = "R") {
	return {
		id: null,
		type,
		x: 0.0,
		y: 0.0,
	}
}

export function getBaseLocationClient() {
	return Object.assign(
		{},
		{
			id: Math.random(1000) * 1000,
			nom: "",
			prenom: "",
			tel: "",
			adresse: "",
			adresse2: "",
			email: "",
			dateNaissance: "",
			permis: "",
			datePermis: "",
			numeroPermis: "",
		},
	)
}

export function getBaseEntretien() {
	return Object.assign(
		{},
		{
			id: Math.random(),
			vehicule: 0,
			part: 0,
			modele: 0,
			debut: "",
			cycle: "",
			cycleType: 0,
			erreur: 0,
			erreurText: "",
			reported: false,
		},
	)
}

export function getBaseConducteur() {
	return Object.assign(
		{},
		{
			id: Math.random(1000) * 1000,
			isClient: false,
			isPrimary: false,
			nom: "",
			prenom: "",
			tel: "",
			adresse: "",
			adresse2: "",
			email: "",
			dateNaissance: "",
			permis: "",
			datePermis: "",
			numeroPermis: "",
		},
	)
}

export function getBaseDep() {
	return Object.assign(
		{},
		{
			id: 0,
			atelier: 0,
			location: 0,
			tva: masterTva(),
			date: moment().format("DD-MM-YYYY"),
			heure: "",
			depanneur: 0,
			matricule: "",
			chassis: "",
			// Points d'intérêt (même forme que DepMission / PointInteretSelectV2 /
			// PointInteret.get_base() : {id, label, type, adresse}).
			lieu_intervention: getBasePointInteret(),
			destination_finale: getBasePointInteret(),
			four: false,
			surPlace: false,
			marque: "",
			plaques: "",
			vehicule_depannage: 0,
			avec_cle: 0,
			nom: "",
			prenom: "",
			telephone: "",
			assurance: "",
			num_dossier: "",
			// Défaut métier : un dépannage saisi directement (sans mission amont)
			// est privé (cf. DEPANNAGE_TYPE_APPEL_DEFAULT côté back).
			appel_type: DEPANNAGE_TYPE_APPEL_PRIVE,
			assistance_entite: 0,
			assistance_entite_label: "",
			type: 0,
			accident_ou_enlevement: 0,
			vehicule_categorie: 0,
			secteur_police: 0,
			assuranceSinistre: "",
			numSinistre: "",
			franchise: 0,
			rabaisFranchise: 0,
			couvLocation: "",
			marked: false,
			boss: false,
			svpMeca: false,
			cleSupp: 0,
			infoCleSupp: "",
			carteGrise: false,
			infoCarteGrise: "",
			expertDate: "",
			expertDateEffective: "",
			expertNom: "",
			avecPlaques: false,
			infoAvecPlaques: "",
			polAutre: "",
			effetsPers: "",
			baseTot: 0,
			hSupQ: 0,
			hSupT: 0,
			hSupTot: 0,
			hSupInfo: "",
			gardQ: 0,
			gardT: 0,
			gardTot: 0,
			gardInfo: "",
			restiDate: "",
			restiHeure: "",
			restiTot: 0,
			restiInfo: "",
			restiReprisPar: "",
			livDate: "",
			livEmp: 0,
			livTot: 0,
			livInfo: "",
			livHeure: "",
			livVeh: 0,
			autreTot: 0,
			autreInfo: "",
			totalFinal: 0,
			paid: false,
			// Cycle de vie de la fiche (DEPANNAGE_ETAT_*, calculé/validé côté
			// serveur — le front ne fait que l'afficher pour l'instant).
			etat: DEPANNAGE_ETAT_EN_COURS,
			modele: "",
			fautifNom: "",
			fautifVoiture: "",
			fautifPlaques: "",
			fautifAssurance: "",
			plaquesReprisLe: "",
			carteGriseDate: "",
			// Transactions du modèle général (saisie fiche + encaissements
			// terrain re-liés) — DepTransaction est mort.
			transactionsv2: [],
			notes: [
				{
					id: 0,
					text: "",
					print: true,
				},
			],
			autres: [
				{
					id: 0,
					info: "",
					total: 0,
				},
			],
			livraisons: [
				{
					id: Math.random(),
					heure: "",
					date: "",
					employe: 0,
					vehicule: 0,
					destination_ligne_0: "",
					destination_ligne_1: "",
					destination_ligne_2: "",
					destination_id: 0,
					destination_type: 0,
					tot: 0,
					destination_adresse: {
						id: Math.random(),
						ligne_0: "",
						ligne_1: "",
						ligne_2: "",
						type: 0,
						isParc: false,
					},
				},
			],
		},
	)
}

export function getBaseDepMission() {
	return Object.assign(
		{},
		{
			id: null,
			dep_id: null,
			etat: DEP_STATE_CHECK_DATA,
			total: 0.0,
			total_presume: 0,
			cree_le: null,
			lieu_intervention: getBasePointInteret(),
			secteur_police: 0,
			appel_id: 0,
			// Donneur d'ordre nouveau référentiel (Entite type Assistance).
			assistance_entite: 0,
			num_dossier: "",
			assurance: "",
			diagnostique_presume: "",
			nom: "",
			prenom: "",
			telephone: "",
			marque: "",
			modele: "",
			plaques: "",
			info_depanneur: "",
			depanneur_id: 0,
			vehicule_depannage_id: 0,
			timestamp_0: null,
			timestamp_1: null,
			timestamp_2: null,
			timestamp_3: null,
			diagnostique_final: "",
			diagnostique_type: 0,
			diagnostique_id: 0,
			destination_finale_0: "",
			destination_finale_1: "",
			destination_finale_2: "",
			destination_finale: getBasePointInteret(),
			destination_intermediaire: null,
			diagnostique_police: 0,
			accident_ou_enlevement: 0,
			avec_cle: false,
			matricule: "",
			date_rendez_vous: null,
			delta_rendez_vous: 0,
			vehicule_categorie: 0,
			kms: 0,
			temps: "",
			type: DEP_TYPE_TRANSPORT,
			appel_type: -1,
			articles: [],
			creer_fiche_meca: false,
		},
	)
}
